<template>
  <v-row no-gutters>
    <v-col>
      <div class="text-h6 mt-2">
        Configuration du Crawler
      </div>
    </v-col>
    <v-col class="text-right">
      Type de crawler :
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            {{ name }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item link @click="change(aName)" v-for="aName in configNames" :key="aName">
            <v-list-item-title>{{ aName }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      version :
      <v-menu v-if="activeConfig" :key="activeConfig.name + activeConfig.version">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" v-if="activeConfig" class="text-lowercase">
            <v-icon left v-if="activeConfig.production">mdi-cloud-check</v-icon>
            v.{{ activeConfig.version }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            link @click="change(name, config.version)"
            v-for="config in versionConfigs" :key="config.version">
            <v-list-item-title>
              <v-icon left v-if="config.production">mdi-cloud-check</v-icon>
              v.{{ config.version }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CrawlerConfigSelector',
  props: ['configs', 'name', 'version'],
  computed: {
    configNames () {
      const names = {}
      for (let config of this.configs) {
        names[config.name] = true
      }
      return Object.keys(names)
    },

    versionConfigs () {
      return this.configs.filter(config => config.name === this.name).slice().reverse()
    },

    activeConfig () {
      return this.configs.find(config => {
        return config.name === this.name && config.version === this.version
      })
    }
  },
  methods: {
    change (name, version) {
      name = name ? name : 'Recent Firefox'
      version = version ? version : Math.max.apply(Math, this.configs
        .filter(config => config.name === name)
        .map(config => config.version)
      )

      this.$emit('update:name', name)
      this.$emit('update:version', version)
      this.$emit('changed')
    }
  },
  created () {
    this.change()
  }
}
</script>

<style scoped>

</style>